import { ServiceRepeatType } from './enums'

export const Queries = {
  ME: 'me',
  BOATS: 'boats',
  BOAT: 'boat',
  ASSET: 'asset',
  BOAT_DEADLINES: 'boat-deadlines',
  BOATS_FOR_CLIENT: 'boats-for-client',
  BOATS_FOR_USER: 'boats-for-user',
  BOAT_CARD_INFO: 'boat-card-info',
  CLIENT_DEADLINES: 'client-deadlines',
  HAVBRUKSLOGGEN_INFORMATION: 'havbruksloggen-information',
  BOAT_USERS: 'boat-users',
  AIS_DATA_FOR_BOATS: 'ais-data-for-boats',
  BOAT_SIDEBAR_STATISTICS: 'boat-sidebar-statistics',
  MY_WORK: 'my-work',
  MY_DEVIATIONS: 'my-deviations',
  MY_WORKORDERS: 'my-workorders',
  MAIN_SIDEBAR_STATISTICS: 'main-sidebar-statistics',
  AIS_DATA_FOR_BOAT: (boatId: EntityId) => ['ais-data-for-boats', boatId],
  SFI_EQUIPMENT_TREE: 'sfi-equipment-tree',
  CLIENT_BOATS: 'client-boats',
  CLIENT_ASSETS: 'client-assets',
  PRODUCTS: 'products',
  SEARCH_PRODUCTS: 'search-products',
  SEARCH_MAINCATEGORIES: 'search-maincategories',
  PRODUCT: 'product',
  STOCKS_BY_CLIENT: 'stocks-by-client',
  STOCKS: 'stocks',
  STOCK: 'stock',
  STOCK_EQUIPMENTS: 'stock-equipments',
  STOCK_PRODUCTS: 'stock-products',
  STOCK_PRODUCTS_MAINTENANCE: 'stock-products-maintenance',
  STOCK_PRODUCT_TRANSACTIONS: 'stock-product-transactions',
  PRODUCT_CATEGORIES: 'product-categories',
  PRODUCT_CATEGORY: 'product-category',
  PRODUCT_UNITS: 'product-units',
  PRODUCT_UNIT: 'product-unit',
  PRODUCT_REQUESTS: 'product-requests',
  TRANSACTION_REQUESTS: 'transaction-requests',
  PRODUCT_GROUPS: 'product-groups',
  PRODUCT_GROUP: 'product-group',
  PRODUCT_GROUP_CHILDREN: 'product-group-children',
  PRODUCT_GROUP_VALID_CHILDREN: 'product-group-valid-children',
  ABC_CATEGORIZATION: 'abc-categorization',
  ABC_CATEGORIES: 'abc-categories',
  ORDER_SUGGESTIONS: 'order-suggestions',
  USER_CLIENTS: 'user-clients',
  USER_CLIENTS_BOATLIST: 'user-clients-boatlist',
  USER_CLIENTS_WITH_PARTNERS: 'user-clients-with-partners',
  USER_DASHBOARD: 'user-dashboard',
  USER_DASHBOARD_MAINTENANCE: 'user-dashboard-maintenance',
  USER_DASHBOARD_MAINTENANCE_CHART: 'user-dashboard-maintenance-chart',
  USER_DASHBOARD_DOCUMENTS_CHART: 'user-dashboard-documents-chart',
  USER_DASHBOARD_DEVIATION_CHART: 'user-dashboard-deviation-chart',
  WORK_ORDERS: 'work-orders',
  WORK_ORDER: 'work-order',
  WORK_ORDER_ITEMS: 'work-order-items',
  WORKCASE_ITEMS: 'workcase-items',
  DEVIATIONS: 'deviations',
  DEVIATIONS_FOR_WORKORDERS: 'deviations-for-workorders',
  DEVIATION: 'deviation',
  DEVIATION_STATUSES: 'deviation-statuses',
  SERVICES: 'services',
  SPARE_PARTS: 'spare-parts',
  SERVICE_OVERVIEW_FOR_EQUIPMENT: 'service-overview-for-equipment',
  EQUIPMENT: 'equipment',
  EQUIPMENT_COUNTER_DATA: 'equipment-counter-data',
  EQUIPMENT_IDS: 'equipment-ids',
  EQUIPMENT_ID_AND_TITLE: 'equipment-id-and-title',
  EQUIPMENT_DOCUMENTS: 'equipment-documents',
  EQUIPMENT_SINGLE: 'equipment-single',
  EQUIPMENT_DETAILS: 'equipment-details',
  EQUIPMENT_FOR_DASHBOARD: 'dashboard-equipments',
  EQUIPMENT_FOR_BOAT: 'equipment-for-boat',
  DEFIBRILLATOR: 'defibrillator',
  DOCUMENT_CATEGORIES: 'document-categories',
  DOCUMENTS_FOR_DASHBOARD: 'dashboard-documents',
  BOAT_DOCUMENTS_FOR_DASHBOARD: (id: EntityId) => [Queries.DOCUMENTS_FOR_DASHBOARD, id],
  DOCUMENTS_FOR_USER: 'documents-for-user',
  DOCUMENTS_FOR_USER_CATEGORIES: 'documents-for-user-categories',
  DOCUMENT_REVISIONS: 'document-revisions',
  SUPPLIERS_FROM_ORGNR: 'suppliers-from-orgnr',
  SUPPLIERS_GLOBAL_AND_LOCAL: 'suppliers-global-and-local',
  SUPPLIERS_GLOBAL: 'suppliers-global',
  SUPPLIERS: 'suppliers',
  DEVIATION_TAGS: 'deviation-tags',
  DEVIATION_TYPES: 'deviation-types',
  DEVIATION_PRIORITIES: 'deviation-priorities',
  WORK_ORDER_SECTIONS: 'work-order-sections',
  WORK_ORDER_SECTION: 'work-order-section',
  WORK_ORDER_FROM_TOKEN: 'work-order-token',
  WORK_ORDER_SECTION_FROM_TOKEN: 'work-order-section-token',
  SECTION_TEMPLATES: 'section-templates',
  DATA_SOURCES: 'data-sources',
  DATA_SOURCES_BY_TYPE: 'data-sources-by-type',
  DATA_SOURCE: 'data-source',
  DATA_FROM_SOURCE: 'data-from-data-source',
  WILL_DEVIATION_BE_SYNCED_EXTERNALLY: 'deviation-synced-externally',
  IS_USER_FAMILIARIZED_ON_BOAT: 'is-user-familiarized-on-boat',
  FETCH_FAMILIARIZATION_FORM_FOR_BOAT: 'fetch-familiarization-form-for-boat',
  FETCH_NOT_FILLED_FAMILIARIZATION_FORM_FOR_BOAT: 'fetch-not-filled-familiarization-form-for-boat',
  CLIENT_AND_PARTNERS_FOR_USER: 'client-and-partners-for-user',
  SECURITY_MANAGEMENTS_FOR_CLIENT: 'security-managements-for-client',
  SECURITY_MANAGEMENTS_FOR_BOAT: 'security-managements-for-boat',
  BOAT_MAINTENANCE_HISTORY: 'boat-maintenance-history',
  CLIENT_SEARCH_USERS: 'client-search-users',
  SOP: 'sop',
  SOP_SINGLE: 'sop-single',
  SOP_CONNECTIONS: 'sop-connections',
  SOP_FOR_SERVICE: 'sop-for-service',
  CODE_VERSION: 'code-version',
  CLIENTSETTING: (setting, clientId) => ['client-setting', setting, clientId],
  CLIENTSETTING_FAMILIARIZATION: 'client-setting-familiarization',
  CLIENTSETTING_WORKORDERS_EMAILS: 'client-setting-workorders-emails',
  FAMILIARIZATION_APPROVAL: 'familiarization-approval',
  FAMILIARIZATION_APPROVAL_SINGLE: 'familiarization-approval-single',
  FAMILIARIZATION_REQUIRES_APPROVAL: 'familiarization-requires-approval',
  CHECKLISTS: 'checklists',
  CHECKLISTSBYWORKSHOPBOAT: 'checklists_by_workshopboat',
  CHECKLIST: 'checklist',
  CHECKLIST_ITEMS: 'checklist-items',
  CHECKLIST_COMPLETIONS: 'checklist_completions',
  CHECKLIST_COMPLETION: 'checklist_completion',
  WORK_ORDER_TEMPLATES: 'work-order-templates',
  WORK_ORDER_TEMPLATE: 'work-order-template',
  STARTUP_ROUTINES: 'startup-routines',
  STARTUP_ROUTINE: 'startup-routine',
  STARTUP_ROUTINE_DASHBOARD: 'startup-routine-dashboard',
  SHUTDOWN_ROUTINE: 'shutdown-routine',
  ROUTINES_DASHBOARD: 'routines-dashboard',
  VALID_BOATS_FOR_ROUTINE: 'boats-for-routine',
  BOAT_HOUR_COUNTERS: 'boat-hour-counters',
  CHECKLIST_ITEM_COUNTER: 'checklist-item-counter',
  CREW_FOR_BOAT: 'crew-for-boat',
  ASSET_USERS: 'asset-users',
  ADMIN_CREW_FOR_BOAT: 'admin-crew-for-boat',
  FAMILIARIZED_STATUS_CREW_FOR_BOAT: 'familiarized-status-crew-for-boat',
  FAMILIARIZATIONS_TO_APPROVE_FOR_BOAT: 'familiarizations-to-approve-for-boat',
  CREW_CHECKINS_CLIENT: 'crew-checkins-client',
  CREW_CHECKINS_BOAT: 'crew-checkins-boat',
  CREW_CHECKINS: 'crew-checkins',
  CREW_CHECKINS_SHUTDOWN: 'crew-checkins-shutdown',
  CHECKINS_FOR_USER: 'checkins-for-user',
  CREW_DAILY_CHECKINS: 'crew-daily-checkins',
  POPULAR_CREW_CHECKINS: 'popular-crew-checkins',
  MISSING_CHECKINS: 'missing-checkins',
  DUPLICATE_SERVICE_OCCURRENCES: 'duplicate-service-occurrences',
  CREW_ROLES: 'crew-roles',
  BOAT_ROUTINE_CHECKLIST_COMPLETION: 'boat-routine-checklist-completion',
  BOAT_ROUTINE_DAILY_CHECKLIST_COMPLETION: 'boat-routine-daily-checklist-completion',
  BOAT_ROUTINE_SHUTDOWN_CHECKLIST_COMPLETION: 'boat-routine-shutdown-checklist-completion',
  ROUTINE_HISTORY: 'routine-history',
  ROUTINE_HISTORY_SINGLE: 'routine-history-single',
  BOOK_SHELF: 'book-shelf',
  BOAT_CHECKLISTS: 'boat-checklists',
  DOCUMENTS_FOR_EQUIPMENT: 'documents-for-equipment',
  BOAT_COUNTER_MOVER: 'boat-counter-mover',
  BOAT_COUNTER_INFO: 'boat-counter-info',
  BOAT_COUNTER_POINTERS: 'boat-counter-pointers',
  BOAT_COUNTER_MAP_FOR_BOAT: 'boat-counter-map-for-boat',
  BOAT_COUNTER_MAP_FOR_BOAT_AND_EQUIPMENT: 'boat-counter-map-for-boat-and-equipment',
  BOAT_COUNTER_MAP: 'boat-counter-map',
  BOAT_COUNTER_LOG_LINES_CONNECTIONS: 'boat-counter-log-lines-connections',
  EQUIPMENT_METADATA: 'equipment-metadata',
  EQUIPMENT_MAINTENANCE_HISTORY: 'equipment-maintenance-history',
  EQUIPMENT_DEVIATIONS: 'equipment-deviations',
  CONNECTED_EQUIPMENT_DEVIATIONS: 'connected-equipment-deviations',
  EQUIPMENT_LOGBOOK: 'equipment-logbook',
  EQUIPMENT_WORKORDER: 'equipment-work-order',
  ALL_CLIENTS: 'all-clients',
  ALL_BOATS_FOR_ALL_CLIENTS: 'all-boats-for-all-clients',
  RISK_ANALYSIS_TASKS: 'risk-analysis-tasks',
  RISK_ANALYSIS_TASK: 'risk-analysis-task',
  RISK_ANALYSIS_SUBTASKS: 'risk-analysis-subtasks',
  BOAT_RISK_ANALYSIS_TASKS: 'boat-risk-analysis-tasks',
  BOAT_RISK_ANALYSIS_TASKS_ALL: 'boat-risk-analysis-tasks-all',
  BOAT_RISK_ANALYSIS_SUBTASKS: 'boat-risk-analysis-subtasks',
  BOAT_RISK_ANALYSIS_SUBTASK_DANGERS: 'boat-risk-analysis-subtasks-dangers',
  BOAT_RISK_ANALYSIS_SUBTASK_DANGER_MEASURES: 'boat-risk-analysis-subtasks-danger-measures',
  BOAT_RISK_ANALYSIS_SUBTASK_DANGER_MEASURE: 'boat-risk-analysis-subtasks-danger-measure',
  BOAT_RISK_ANALYSIS_GENERAL_INFO: 'boat-risk-analysis-general-info',
  RISK_ANALYSIS_TASKS_SUPERADMIN: 'risk-analysis-tasks-superadmin',
  RISK_ANALYSIS_TASK_SUPERADMIN: 'risk-analysis-task-superadmin',
  WORKSHOPS: 'workshops',
  WORKSHOP: 'workshop',
  WORKSHOP_AVAILABLE_USERS: 'workshop-available-users',
  BOAT_WORKSHOPS: 'boat-workshops',
  BOAT_WORKSHOPS_USERS: 'boat-workshops-users',
  FAMILIARIZATION_HISTORY: 'familiarization-history',
  FAMILIARIZATION_FOLDER: 'familiarization-folder',
  BOAT_WORKSHOP_STATUS: 'boat-workshop-status',
  BOAT_ACTIVE_WORKSHOP: 'boat-active-workshop',
  MY_WORKSHOPS: 'my-workshops',
  WORKSHOP_WORK_ORDERS: 'workshop-work-orders',
  WORKSHOP_BOAT_WORK_ORDERS: 'workshop-boat-workorders',
  WORKSHOP_BOATS: 'workshop-boats',
  WORKSHOP_BOAT_STATUS: 'workshop-boat-status',
  WORKSHOP_ACTIVE_BOATS: 'workshop-active-boats',
  WORKSHOP_MY_BOATS: 'workshop-my-boats',
  WORKSHOP_TOTAL_WORKCASES: 'workshop-total-workcases',
  PLANNED_WORKCASES: 'planned-workcases',
  WORKSHOP_COMPLETED_BOATS: 'workshop-completed-boats',
  WORKSHOP_OVERVIEW: 'workshop-overview',
  WORKSHOP_WORK_ORDER_HISTORY: 'workshop-workorder-history',
  USER_NOTIFICATIONS: 'user-notifications',
  REFUEL_COUNTERS_FOR_BOAT: 'refuel-counters-for-boat',
  HOUR_COUNTERS_FOR_BOAT: 'hour-counters-for-boat',
  COUNTER_SERVICES_FOR_DASHBOARD: 'counter-services-for-dashboard',
  SERVICES_FOR_DASHBOARD: 'services-for-dashboard',
  SERVICE_FOR_DASHBOARD: (id: EntityId) => [Queries.SERVICES_FOR_DASHBOARD, id],
  LAST_SERVICE_DATES: 'last-service-dates',
  LAST_SERVICES_DATES: (id: EntityId) => [Queries.LAST_SERVICE_DATES, id],
  GET_SERVICES: 'get-services',
  GET_EQUIPMENT_TEMPLATE_SERVICES: 'get-equipment-template-services',
  GET_EQUIPMENT_TEMPLATE_COUNTER_SERVICES: 'get-equipment-template-counter-services',
  GET_EQUIPMENT_TEMPLATES_FOR_CLIENT: 'get-equipment-templates-for-client',
  GET_SUPPLIERS_FOR_CLIENT: 'get-suppliers-for-client',
  GET_COUNTER_SERVICES: 'get-counter-services',
  GET_COUNTER_SERVICES_TEMPLATES: 'get-counter-services-templates',
  GET_COUNTER_SERVICES_OCCURRENCES: 'get-counter-services-occurrences',
  GET_COUNTERS_WITH_LOGS_FOR_BOAT: 'get-counters-with-logs-for-boat',
  GET_LAST_ENTRIES_FOR_MAINCOUNTERS: 'get-last-entries-for-maincounters',
  NOT_DONE_BOAT_EXERCISE_OCCURENCES: 'not-done-boat-exercise-occurences',
  SUMMARIZED_ENTRIES: 'summarized-entries',
  BOAT_COUNTERS_WITH_USAGE: 'boat-counters-with-usage',
  EQUIPMENT_COUNTERS_WITH_USAGE: 'equipment-counters-with-usage',
  ALLOWED_COUNTERS_WITH_USAGE: 'allowed-counters-with-usage',
  BOAT_COUNTER: 'boat-counter',
  BOAT_COUNTER_SERVICE_CONTROL: 'boat-counter-service-control',
  COUNTER_UNITS: 'counter-unit',
  BOAT_COUNTER_TYPES: 'boat-counter-types',
  UNITS: 'units',
  USER_EMAILS: 'user-emails',
  USER_SESSIONS: 'user-sessions',
  BOAT_EQUIPMENT_DOCUMENTS: 'boat-equipment-documents',
  BOAT_MAINTENANCE_DOCUMENTS: 'boat-maintenance-documents',
  BOAT_DOCUMENTS: 'boat-documents',
  BOAT_DOCUMENT_FOLDERS: 'boat-document-folders',
  FILE_FOLDER: 'file-folder',
  DOCUMENTS: 'documents',
  LOCALITIES_FOR_CLIENT: 'localities-for-client',
  CALENDAR_MONTH_EVENTS: (start: Date, end: Date, view?: string, boatId?: EntityId) => [
    'calendar-month',
    start.getDate(),
    end.getDate(),
    view,
    boatId,
  ],
  BOAT_CALENDAR_SERVICE: (boatId: EntityId, serviceType: ServiceRepeatType) => [
    'boat-calendar-service',
    boatId,
    serviceType,
  ],
  DEVIATIONS_FOR_CLIENT: 'deviations-for-client',
  READ_ONLY_USERS: 'read-only-users',
  CHANGELOG: 'changelog',
  CHANGELOG_TAGS: 'changelog_tags',
  EXERCISES: 'exercises',
  BOAT_OVERVIEW_EXERCISES: 'boat-exercises',
  EXERCISE: (id: EntityId) => [Queries.EXERCISES, id],
  BOAT_EXERCISES: (boatId: EntityId) => ['boat-exercises', boatId],
  BOAT_EXERCISE: (exerciseId: EntityId) => ['boat-exercise', exerciseId],
  COMPLETED_BOAT_EXERCISE_OCCURENCES: 'completed-boat-exercise-occurrences',
  BOAT_EXERCISE_OCCURENCES: (boatId: EntityId, start: Date, end: Date) => ['exercise-occurences', boatId, start, end],
  BOAT_EXERCISE_OCCURENCES_NOT_COMPLETE: (boatId: EntityId, start: Date, end: Date) => [
    'exercise-occurences-not-complete',
    boatId,
    start,
    end,
  ],
  BOAT_EXERCISE_OCCURENCES_NOT_COMPLETE_PURE: 'exercise-occurences-not-complete',
  BOAT_EXERCISE_OCCURENCE_OVERVIEW: (boatId: EntityId) => ['exercise-overview', boatId],
  BOAT_EXERCISE_DB_OCCURENCE: (id: EntityId) => ['db-occurence', id],
  CLIENT_ACCESS_GROUPS: (clientId: EntityId) => ['client-ac-groups', clientId],
  CLIENT_ACCESS_GROUP: (clientId: EntityId, clientAccessGroupID: EntityId) => [
    'client-ac-group',
    clientId,
    clientAccessGroupID,
  ],
  VESSEL_GROUP: 'client-vessel-groups',
  CLIENT_ACCESS_GROUP_MANAGE_OPERATIONS: 'ClientAccessGroupManageOperations',
  CLIENT_ADMINS: 'client-admins',
  CLIENT_ADMIN_BOAT_USERS: (boatId: EntityId) => ['client-admin-boat-users', boatId],
  BOAT_TYPES: 'boat-types',
  BOAT_TYPE_CATEGORIES: 'boat-type-categories',
  BOAT_TRADE_AREAS: 'boat-trade-areas',
  BOAT_HULL_TYPES: 'boat-hull-types',
  CLIENT_DOCUMENT_TEMPLATES: (clientId: EntityId) => ['client-document-templates', clientId],
  USER_BOATS_DUE_DATES_OVERVIEW: 'boats-due-dates-overview',
  BOATS_DUE_DATES_OVERVIEW: 'boats-due-dates-overview',
  BOAT_DUE_DATES_OVERVIEW: 'boat-due-dates-overview',
  VESSEL_DOCUMENTS_FOR_BOAT: 'vessel-documents-for-boat',
  DOCUMENTS_CLOSE_TO_DUE_FOR_BOAT: 'DOCUMENTS_CLOSE_TO_DUE_FOR_BOAT',
  DOCUMENTS_CLOSE_TO_DUE_FOR_CLIENT: 'DOCUMENTS_CLOSE_TO_DUE_FOR_CLIENT',
  GLOBAL_ALERT: 'global-alert',
  ACCESS_GROUPS_FOR_CLIENT: 'access-groups-for-client',
  ACCESS_GROUP_MANAGERS: boatAccessGroups => ['accessGroupManagers', boatAccessGroups],
  WORKSHOP_USERS: 'workshop-users',
  WORKCASE_ASSIGNABLE_USERS: 'workcase-assignable-users',
  ALL_WORKSHOP_USERS: 'all-workshop-users',
  WORKSHOP_ROLES: 'workshop-roles',
  WORK_ORDERS_FOR_WORKSHOP_USERS: 'work-orders-for-workshop-users',
  WORK_ORDERS_FOR_WORKSHOP_USERS_TIME: 'work-orders-for-workshop-users_time',
  BOATS_FOR_WORKSHOP_USERS: 'boats-for-workshop-users',
  WORK_ORDERS_FOR_WORKSHOP_USERS_CALENDAR: 'work-orders-for-workshop-users-calendar',
  HAVBRUKSLOGGEN_GET_LOCALITIES_FOR_CLIENT: 'havbruksloggen-get-localities-for-client',
  WORKSHOP_BOAT_SERVICES: 'workshop-boat-services',
  WORK_ORDERS_FOR_WORKSHOP: 'work-orders-for-workshop',
  LOGBOOK_ENTRIES: 'logbook-entries',
  GET_SENSOR_TYPES: 'get-sensor-type',
  GET_SENSOR_TYPES_BY_MMSI: 'get-sensor-type-by-mmsi',
  GET_SENSOR_CONFIG: 'get-sensor-config',
  GET_SENSOR_DISTRIBUTOR: 'get-sensor-distributor',
  GET_SENSOR_DASHBOARD_PERMISSION: 'get-sensor-dashboard-permission',
  GET_CLIENT_ROLES: 'get-client-roles',
  GET_USER_MANAGEMENT_CLIENT_ROLES: 'get-user-management-client-roles',
  GET_ASSET_ROLES: 'get-boat-roles',
  GET_DEFAULT_ROLE_FOR_USER: 'get-default-role-for-user',
  GET_SYSTEM_ROLES: 'get-system-roles',
  GET_SYSTEM_ROLE_PERMISSIONS: 'get-system-role_permission',
  GET_CLIENT_ROLE_PERMISSIONS: 'get-client-role_permission',
  GET_BOAT_ROLE_PERMISSIONS: 'get-boat-role_permission',
  GET_BOAT_ROLE_DIRECT_PERMISSIONS: 'get-boat-role_direct_permission',
  GET_BOAT_ROLE_DIRECT_PERMISSIONS_USERS: (boatId: EntityId) => ['get-boat-role_direct_permission_users', boatId],
  GET_CLIENT_DIRECT_PERMISSIONS_USERS: (clientId: EntityId) => ['get-client_direct_permission_users', clientId],
  MAINCATEGORIESLVL0: 'maincategorieslvl0',
  MAINCATEGORIESLVL1: 'maincategorieslvl1',
  MAINCATEGORIESLVL2: 'maincategorieslvl2',
  MAINCATEGORIESLVL3: 'maincategorieslvl3',
  MAINCATEGORIESTREE: 'maincategories-tree',
  LOGBOOK_CATEGORIES: 'logbook-categories',
  USERS_FOR_CLIENT: 'users-for-client',
  APPLICATIONS: 'all-applications',
  APPLICATION_CUSTOMERS: 'applications-customers',
  USER_ACCESS_DETAILS: 'user-access-details',
  ACCESS_GROUP_BY_BOAT: 'access-group-by-id',
  WEATHER_DETAILS: 'weather-details',
  DOCUMENT_TEMPLATES_FOR_BOAT: 'document-templates-for-boat',
  TAGS_FOR_CLIENT: 'tags-for-client',
  ADMIN_DASHBOARD_OVERVIEW: 'admin_dashboard_overview',
  ADMIN_DASHBOARD_MAINTENANCE_OVERVIEW: 'admin_dashboard_maintenance_overview',
  ADMIN_DASHBOARD_MAINTENANCE_CHART: 'admin_dashboard_maintenance_chart',
  ADMIN_DASHBOARD_DOCUMENTS_OVERVIEW: 'admin_dashboard_documents_overview',
  ADMIN_DASHBOARD_DOCUMENTS_CHART: 'admin_dashboard_documents_chart',
  ADMIN_DASHBOARD_DEVIATION_OVERVIEW: 'admin_dashboard_deviation_overview',
  ADMIN_DASHBOARD_DEVIATION_CHART: 'admin_dashboard_deviation_chart',
  AUDITS: 'audits',
  AUDITS_TOTAL: 'audits-total',
  EQUIPMENT_CHECKLISTS: 'equipment-checklists',
  BOAT_WORKSHOP_WORK_ORDERS: 'boat-workshop-work-orders',
  BOAT_WORKSHOP_CASES: 'boat-workshop-cases',
  CONNECTED_SERVICES_ATTACHMENTS: 'connected-services-attachments',
  FAMILIARIZATION_FORMS_FOR_CLIENT: 'familiarization-forms-for-client',
  FAMILIARIZATION_BOATS_FOR_CLIENT: 'familiarization-boats-for-client',
  HAS_USER_TO_MIGRATE: 'has_user_to_migrate',
  WORKSHOP_BOAT_WORK_CASES: 'workshop-boat-workcases',
  GET_USER_PASSWORD_RESET_LINK: 'get-user-password-reset-link',
  GET_USER_PASSWORD_REGISTER_LINK: 'get-user-password-register-link',
  INTRANET_USERS: 'internet-users',
  EQUIPMENT_TEMPLATE_USED_ON_BOAT: 'equipment-template-used-on-boat',
  EQUIPMENT_TEMPLATES: 'equipment-templates',
  ALLOCATIONS_FOR_CLIENT: 'allocations-for-client',
  USER_LANGUAGE: 'user-language',
  CLIENT_SETTINGS: 'client-settings',
  ADMIN_CLIENTS_FOR_USER: 'admin-clients-for-user',
  DOCUMENT_TEMPLATES_FOR_CLIENT: 'document-templates-for-client',
  WORKSHOP_BOATS_DATA: 'workshop-boats-data',
  System_USER_ACTIVE_BOATS: 'system-user-active-boats',
  WORKSHOP_WORK_ORDER_STATUS: 'workshop_workoder_status',
  UNASSIGNED_WORKSHOP_WORK_ORDERS: 'unassigned_workshop_work_orders',
  WORKSHOP_BOAT_HISTORY: 'workshop_boat_history',
  EQUIPMENT_HISTORY: 'equipment-history',
  STOCK_PRODUCT_COUNT: 'stock-product-count',
  ALL_STOCKS_BY_CLIENT: 'all-stocks-by-client',
  DISPOSED_STOCK_PRODUCTS: 'disposed-stock-products',
  DISPOSED_EQUIPMENT: 'disposed-equipment',
  STOCK_USERS: 'stock-users',
  STOCK_ROLES: 'stock-roles',
  ALLOCATIONS_BOATS_FOR_CLIENT: 'allocations-boats-for-client',
  CLIENT_WORKSHOPS: 'client_workshops',
  WORKSHOP_USERS_DROPDOWN: 'workshop-users-dropdown',
  CLIENT_USER_LINK: 'client_user_link',
  USER_VESSEL_GROUPS: 'user-vessel-groups',
  GET_MAINTENANCE_TAGS: 'get-maintenance-tags',
  CERTIFICATE_TEMPLATE: 'certificate-template',
  CUSTOMER_CERTIFICATE_TEMPLATE: 'certificate-template',
  CERTIFICATE_TEMPLATE_VERSION: 'certificate-template-version',
  CLINET_CERTIFICATE_TEMPLATE_VERSION: 'client-certificate-template-version',
  BOAT_CERTIFICATE_TYPES: 'boat-certificate-types',
  BOAT_CERTIFICATE_DATA: 'boat-certificate-data',
  BOAT_CERTIFICATE_HISTORY: 'boat-certificate-history',
  LATEST_CERTIFICATE_LAYOUT: 'latest_certificate-layout',
  CERTIFICATE_LAYOUT: 'certificate-layout',
  ALL_CERTIFICATE_LAYOUTS: 'all-certificate-layouts',
  ALL_CLIENT_CERTIFICATE_LAYOUTS: 'all-client-certificate-layouts',
  CERTIFICATE_VERSION_LAYOUT: 'certificate-version-layout',
  CLIENT_LATEST_CERTIFICATES: 'client-latest-certificates',
  BOAT_TEMPLATE_SECTION: 'boat-template-section',
  CERTIFICATE_TEMPLATE_INFO: 'certificate-template-info',
  BOAT_DEVIATION: 'boat-deviation',
  FEATURES: 'features',
  CLIENT_FEATURES: 'client-features',
  CLIENT_FEATURE_MAPPINGS: 'client-feature-mapping',
  CLIENT_PRODUCT_CATEGORIES: 'client-product-categories',
  COMMON_PRODUCT_CATEGORIES: 'common-product-categories',
  LUBRICANTS: 'lubricants',
  EQUIPMENT_LUBRICANT_MAP: 'equipment-lubricant-map',
  BOAT_LUBRICANT_MAP: 'boat-lubricant-map',
  BOAT_WORKCASE_INFO: 'boat-workcase-info',
  BOAT_ALL_WORKCASES: 'boat-all-workcases',
  SHOW_EXERCISES_ON_BOATS: 'show-exercises-on-boats',
  VALIDATEREGTOKEN: 'validate-reg-token',
  GET_WORKSHOP_USER_NOTIFICATION_PREFERENCE: 'get-workshop-user-notification-preference',
  VESSEL_TYPE: 'vessel-type',
  BOAT_STORAGE: 'boat-storage',
  BOAT_STOCK: 'boat-stock',
  HAS_ACTIVE_CAPTAIN: 'has-active-captain',
  DIRECT_BOAT_MANAGERS: 'direct-boat-managers',
  HAS_ACTIVE_CAPTAIN_SHUTDOWN: 'has-active-captain-shutdown',
  WORKSHOP_USER_DAILY_WORK_CASES: 'workshop-user-daily-work-cases',
  ALL_OVERDUE_WORK_CASES: 'all_overdue_work_cases',
  ALL_OVERDUE_WORK_CASES_TABLE: 'all_overdue_work_cases_table',
  ALL_TOAPPROVE_WORK_CASES: 'all_ToApprove_work_cases',
  OPEN_ORDERS: 'open-orders',
  WORKSHOP_BOATS_SUGGESTIONS: 'workshopboat-suggestions',
  WORKCASE_FOLLOWUPS: 'workcase-followups',
  WORKCASE_ANALYSIS: 'workcase-analysis',
  WORKSHOP_WORKCASES: 'workshop_workcases',
  WORK_ORDER_ANALYSIS: 'work-order-analysis',
  ASSET_SUMMARY_DROPDOWN: 'asset-summary-dropdown',
  IS_CURRENT_USER_CLIENT_ADMIN: 'is-current-user-client-admin',
  MAIN_CATEGORIES: 'main-categories',
  SUB_CATEGORIES: 'sub-categories',
  GET_SELF_ASSESSMENTS: 'get-self-assessments',
  GET_SELF_ASSESSMENT_OVERVIEW: 'GET_SELF_ASSESSMENT_OVERVIEW',
  WORKORDER_DEVIATIONS: 'workorder-deviations',
  GET_ALL_USER_SELF_ASSESSMENTS: 'GET_ALL_USER_SELF_ASSESSMENTS',
  TASKS: 'tasks',
  COMPLETED_WORK_CASE: 'completed-work-case',
}
